var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationLookup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.87,
    d: "M5.04 1.12H13.440000000000001V2.12H5.04z",
    transform: "translate(.56 .56)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.87,
    strokeWidth: 0.64,
    d: "M0 1.185L1.287 2.472 3.758 0",
    transform: "translate(.56 .56)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.87,
    d: "M5.04 1.12H13.440000000000001V2.12H5.04z",
    transform: "translate(.56 5.04)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.87,
    strokeWidth: 0.64,
    d: "M0 1.185L1.287 2.472 3.758 0",
    transform: "translate(.56 5.04)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.87,
    d: "M5.04 1.12H13.440000000000001V2.12H5.04z",
    transform: "translate(.56 9.52)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.87,
    strokeWidth: 0.64,
    d: "M0 1.185L1.287 2.472 3.758 0",
    transform: "translate(.56 9.52)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.75 5.301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.958,
    cy: 3.875,
    r: 2.917,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M3.731 6.296c.467 0 .896-.116 1.29-.35.393-.233.704-.546.932-.94.229-.392.343-.822.343-1.289 0-.466-.114-.896-.343-1.289-.228-.393-.54-.704-.932-.933-.394-.228-.823-.343-1.29-.343-.466 0-.896.115-1.29.343-.393.229-.706.54-.939.933-.233.393-.35.823-.35 1.29 0 .466.117.896.35 1.289.233.393.546.706.94.94.393.233.823.35 1.29.35zm3.43 0L10 9.136 9.136 10l-2.84-2.853v-.453l-.164-.15c-.32.283-.688.5-1.105.65-.416.152-.848.227-1.296.227-.677 0-1.3-.164-1.872-.494-.572-.329-1.022-.772-1.351-1.33C.169 5.02 0 4.394 0 3.717c0-.676.167-1.3.5-1.872C.835 1.273 1.288.823 1.86.494 2.43.164 3.054 0 3.73 0s1.303.17 1.88.508c.557.329.999.777 1.323 1.344.325.567.487 1.189.487 1.865 0 .458-.075.894-.226 1.31-.151.417-.368.785-.652 1.105l.151.164h.466z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationLookup);
export default __webpack_public_path__ + "static/media/verification_lookup.370193b87c4f8773b46ae445a83e0432.svg";
export { ForwardRef as ReactComponent };